import { render, staticRenderFns } from "./PaginationWrapper.vue?vue&type=template&id=91c22cca"
import script from "./PaginationWrapper.vue?vue&type=script&lang=js"
export * from "./PaginationWrapper.vue?vue&type=script&lang=js"
import style0 from "./PaginationWrapper.vue?vue&type=style&index=0&id=91c22cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports